import _objectWithoutProperties from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _regeneratorRuntime from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { START_LOADER, STOP_LOADER } from "./types";
import { USER_LOGIN_REFRESH_SUCCESS, USER_LOGOUT } from "./types/auth";

var base64 = require("base-64");

export var BASE_URL = "https://dit.jmfinancialmf.com/api_proxy/jmmf_dit/25/SmartService.svc";
export var FILE_URL = "https://mfs.kfintech.com/prodapi/image-proxy/ktrackgo/SmartService.svc/ktrack_uploaded_PdfSave";
export var NCT_URL = "https://images.kfintech.com/ktrackgo/SmartService.svc/ktrack_uploaded_PdfSave_NCT";
export var FEED_BACK_URL = "https://mfs.kfintech.com/KTRACKAPI/SmartService.svc";
var FETCH_FAILED = "Failed to fetch"; //will be removed later, using as a placeholder.

export var MIRAE_BASE_URL = "https://clientwebsitesuat2.kfintech.com/uatapi/mirae-proxy/miraeuat/SmartService.svc";

var jwt = require("jsonwebtoken");

import EncryptionUtils from "./encrypt";
var DEFAULT_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json"
};

function invokeAPI(_x, _x2, _x3) {
  return _invokeAPI.apply(this, arguments);
}

function _invokeAPI() {
  _invokeAPI = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(endpoint, config, auth_token) {
    var headers, isFile, isTrackApi, isNct, isotp, isPassword, others, updatedConfig, response, errorMessage, errorResponse, _encryptedBody, _data, responseData, encryptedBody, data, Dtinformation, Table, Table1, _ref3, _ref4, info, errorCode;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            headers = !!auth_token ? _objectSpread({}, DEFAULT_HEADERS, {
              authorization: "Bearer ".concat(auth_token)
            }) : _objectSpread({}, DEFAULT_HEADERS); // const headers = { ...DEFAULT_HEADERS };

            isFile = config.isFile, isTrackApi = config.isTrackApi, isNct = config.isNct, isotp = config.isotp, isPassword = config.isPassword, others = _objectWithoutProperties(config, ["isFile", "isTrackApi", "isNct", "isotp", "isPassword"]);
            updatedConfig = _objectSpread({}, others, {
              headers: headers
            });
            _context2.next = 5;
            return fetch(isNct ? NCT_URL : isFile ? FILE_URL : isTrackApi ? FEED_BACK_URL + endpoint : isotp ? MIRAE_BASE_URL + endpoint : BASE_URL + endpoint, updatedConfig);

          case 5:
            response = _context2.sent;

            if (!(response.status < 200 || response.status >= 300)) {
              _context2.next = 24;
              break;
            }

            errorMessage = "Something went wrong";

            if (!(response.status === 429)) {
              _context2.next = 12;
              break;
            }

            errorMessage = "Too many attempts try after some time.";
            _context2.next = 22;
            break;

          case 12:
            if (!(response.status == 413)) {
              _context2.next = 16;
              break;
            }

            errorMessage = "Upload file size too large. Try uploading a smaller file less than 24 MB or change the file format.";
            _context2.next = 22;
            break;

          case 16:
            _context2.next = 18;
            return response.json();

          case 18:
            errorResponse = _context2.sent;
            _encryptedBody = errorResponse.encryptedBody;
            _data = _encryptedBody ? JSON.parse(new EncryptionUtils().decrypt(_encryptedBody)) : errorResponse;
            errorMessage = _data.error || errorMessage;

          case 22:
            alert(errorMessage);
            throw new Error(errorMessage);

          case 24:
            _context2.next = 26;
            return response.json();

          case 26:
            responseData = _context2.sent;
            encryptedBody = responseData.encryptedBody;
            data = encryptedBody ? JSON.parse(new EncryptionUtils().decrypt(encryptedBody)) : responseData; // const body = JSON.parse(data);

            Dtinformation = data.Dtinformation, Table = data.Table, Table1 = data.Table1;

            if (!(!!Dtinformation || !!Table || Table1)) {
              _context2.next = 42;
              break;
            }

            _ref3 = Dtinformation || Table || Table1, _ref4 = _slicedToArray(_ref3, 1), info = _ref4[0];
            errorCode = !!info ? typeof info.Error_code !== "undefined" ? info.Error_code : info.Error_Code : "";

            if (!(typeof errorCode === "undefined" && !!Dtinformation && !!Dtinformation.length)) {
              _context2.next = 37;
              break;
            }

            return _context2.abrupt("return", data);

          case 37:
            if (!(+errorCode !== 0 && +errorCode !== "0" && !isPassword)) {
              _context2.next = 39;
              break;
            }

            throw info.Error_Message;

          case 39:
            return _context2.abrupt("return", data);

          case 42:
            if (!(!!data && !!data.token)) {
              _context2.next = 44;
              break;
            }

            return _context2.abrupt("return", data);

          case 44:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _invokeAPI.apply(this, arguments);
}

export var CALL_API = Symbol("Call API");
export default (function (store) {
  return function (next) {
    return (
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(action) {
          var _action$CALL_API, url, method, _action$CALL_API$type, types, _action$CALL_API$show, showLoader, _action$CALL_API$body, body, _action$CALL_API$isNc, isNct, _action$CALL_API$ikyc, ikyc, _action$CALL_API$isLo, isLogin, addedparams, params, _action$CALL_API$isot, isotp, _action$CALL_API$isFi, isFile, _action$CALL_API$isTr, isTrackApi, _action$CALL_API$isPa, isPassword, _types, requestType, successType, _store$getState, authReducer, prime_token, _jwt$decode, exp, diff, refresh, queryParams, stringParametrs, responseBody, isValidLogin;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(typeof action[CALL_API] === "undefined")) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return", next(action));

                case 2:
                  // const constantParams = {
                  //   Adminusername: "smartservice",
                  //   Adminpassword: "karvy1234%24",
                  //   OS: "DIT",
                  //   IMEI: "127.0.0.1",
                  //   APKVer: "1.0"
                  // };
                  _action$CALL_API = action[CALL_API], url = _action$CALL_API.url, method = _action$CALL_API.method, _action$CALL_API$type = _action$CALL_API.types, types = _action$CALL_API$type === void 0 ? [] : _action$CALL_API$type, _action$CALL_API$show = _action$CALL_API.showLoader, showLoader = _action$CALL_API$show === void 0 ? false : _action$CALL_API$show, _action$CALL_API$body = _action$CALL_API.body, body = _action$CALL_API$body === void 0 ? undefined : _action$CALL_API$body, _action$CALL_API$isNc = _action$CALL_API.isNct, isNct = _action$CALL_API$isNc === void 0 ? false : _action$CALL_API$isNc, _action$CALL_API$ikyc = _action$CALL_API.ikyc, ikyc = _action$CALL_API$ikyc === void 0 ? false : _action$CALL_API$ikyc, _action$CALL_API$isLo = _action$CALL_API.isLogin, isLogin = _action$CALL_API$isLo === void 0 ? false : _action$CALL_API$isLo, addedparams = _action$CALL_API.addedparams, params = _action$CALL_API.params, _action$CALL_API$isot = _action$CALL_API.isotp, isotp = _action$CALL_API$isot === void 0 ? false : _action$CALL_API$isot, _action$CALL_API$isFi = _action$CALL_API.isFile, isFile = _action$CALL_API$isFi === void 0 ? false : _action$CALL_API$isFi, _action$CALL_API$isTr = _action$CALL_API.isTrackApi, isTrackApi = _action$CALL_API$isTr === void 0 ? false : _action$CALL_API$isTr, _action$CALL_API$isPa = _action$CALL_API.isPassword, isPassword = _action$CALL_API$isPa === void 0 ? false : _action$CALL_API$isPa;
                  params = _objectSpread({}, params);
                  _types = _slicedToArray(types, 2), requestType = _types[0], successType = _types[1];
                  _store$getState = store.getState(), authReducer = _store$getState.authReducer;
                  requestType && next({
                    type: requestType
                  });
                  _context.prev = 7;

                  if (showLoader) {
                    next({
                      type: START_LOADER
                    }); //TODO: Dispatch show modal loader now.
                  }

                  prime_token = authReducer.auth_token;

                  if (!prime_token) {
                    _context.next = 30;
                    break;
                  }

                  _context.prev = 11;
                  _jwt$decode = jwt.decode(prime_token), exp = _jwt$decode.exp;
                  diff = Math.floor(new Date(exp * 1000).getTime() - new Date().getTime());

                  if (!(diff && diff >= 0 && diff <= 5 * 60 * 1000)) {
                    _context.next = 21;
                    break;
                  }

                  _context.next = 17;
                  return invokeAPI("/refresh_token", {
                    method: "GET"
                  }, prime_token);

                case 17:
                  refresh = _context.sent;

                  if (!!refresh && !!refresh.token) {
                    next({
                      body: _objectSpread({}, refresh),
                      type: USER_LOGIN_REFRESH_SUCCESS
                    });
                    prime_token = refresh.token;
                  } else {
                    prime_token = authReducer.token;
                  }

                  _context.next = 24;
                  break;

                case 21:
                  if (!(diff < 0)) {
                    _context.next = 24;
                    break;
                  }

                  next({
                    type: USER_LOGOUT
                  });
                  return _context.abrupt("return");

                case 24:
                  _context.next = 30;
                  break;

                case 26:
                  _context.prev = 26;
                  _context.t0 = _context["catch"](11);
                  next({
                    type: USER_LOGOUT
                  });
                  return _context.abrupt("return");

                case 30:
                  queryParams = objToQueryString(params);
                  stringParametrs = !!ikyc ? queryParams.toString() + "&IMEI=".concat(addedparams.IMEI, "&DistName=").concat(addedparams.DistName, "&Adminpassword=").concat(addedparams.Adminpassword, "&InvEmail=").concat(addedparams.InvEmail, "&ArnCode=").concat(addedparams.ArnCode) : queryParams.toString();
                  _context.next = 34;
                  return invokeAPI(url + "?" + "".concat(stringParametrs, "&customfund=").concat(encodeURIComponent(base64.encode("105")), "&APKVer=").concat(encodeURIComponent(base64.encode("1.0.5"))), {
                    method: method,
                    body: JSON.stringify(body),
                    redirect: "manual",
                    isFile: isFile,
                    isotp: isotp,
                    isNct: isNct,
                    isTrackApi: isTrackApi,
                    isPassword: isPassword
                  }, authReducer.auth_token);

                case 34:
                  responseBody = _context.sent;
                  isValidLogin = validateLogin({
                    isLogin: isLogin,
                    loginPayload: body,
                    responseBody: responseBody
                  });

                  if (isValidLogin) {
                    _context.next = 41;
                    break;
                  }

                  next({
                    type: STOP_LOADER
                  });
                  next({
                    type: USER_LOGOUT
                  });
                  alert("Unauthorized Request");
                  return _context.abrupt("return");

                case 41:
                  successType && next({
                    body: _objectSpread({}, responseBody),
                    type: successType
                  });
                  next({
                    type: STOP_LOADER
                  });
                  return _context.abrupt("return", _objectSpread({}, responseBody));

                case 46:
                  _context.prev = 46;
                  _context.t1 = _context["catch"](7);

                  if (!(_context.t1.message !== FETCH_FAILED)) {
                    _context.next = 52;
                    break;
                  }

                  throw _context.t1;

                case 52:
                  if (!(_context.t1.message === FETCH_FAILED)) {
                    _context.next = 54;
                    break;
                  }

                  return _context.abrupt("return", "Something went wrong!!\n        please check your internet connectivity or try again later");

                case 54:
                  _context.prev = 54;

                  if (showLoader) {
                    next({
                      type: STOP_LOADER
                    }); //TODO: Dispatch hide modal loader now.
                  }

                  return _context.finish(54);

                case 57:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[7, 46, 54, 57], [11, 26]]);
        }));

        return function (_x4) {
          return _ref.apply(this, arguments);
        };
      }()
    );
  };
});

function objToQueryString(obj) {
  var keyValuePairs = [];

  for (var key in obj) {
    keyValuePairs.push(key + "=" + encodeURIComponent(base64.encode(obj[key])));
  }

  return keyValuePairs.join("&");
} // encodeURIComponent(base64.encode())
// + `&IMEI=${encodeURIComponent(base64.encode("127.0.0.1"))}&Adminusername=${encodeURIComponent(base64.encode("smartservice"))}&Adminpassword=${encodeURIComponent(base64.encode("karvy1234%24"))}&OS=${encodeURIComponent(base64.encode("SUNDARAM"))}&APKVer=${encodeURIComponent(base64.encode("1.0"))}`;


function validateLogin(_ref2) {
  var isLogin = _ref2.isLogin,
      loginPayload = _ref2.loginPayload,
      responseBody = _ref2.responseBody;
  if (!isLogin) return true;
  var username = loginPayload.username;

  var _jwt$decode2 = jwt.decode(responseBody.token),
      user = _jwt$decode2.user,
      arn = _jwt$decode2.arn;

  return decrypt(username) === user && responseBody && responseBody.DtData && responseBody.DtData[0] && arn === responseBody.DtData[0].ARNCode;
}

function decrypt(text) {
  var decodedString = base64.decode(text);
  var encrpyted1 = decodedString.slice(11, -16);
  var encrpyted = base64.decode(encrpyted1);
  return encrpyted;
}